module.exports = __webpack_public_path__ + "static/hackathon-8-b1431a8171b407d11f5270618f8b06a3.jpg";